<template>
  <div class="container">
    <div class="result-logo"></div>
    <div class="result-tips">
      1.如果无法打开支付宝APP，请点击「继续浏览器付款」；
    </div>
    <div class="result-tips" style="margin-bottom: 40px;">
      2.如果你已完成付款，请点击「已完成付款」；
    </div>
    <div class="button am-button-blue" @click="setShareInfoStatus">
      继续浏览器支付
    </div>
    <div class="button" @click="toOrderDetail">已完成支付</div>
    <alipay-in-wechat
      v-on:setShareInfoStatus="setShareInfoStatus"
      :isAlipay="isAlipay"
    ></alipay-in-wechat>
  </div>
</template>

<script>
import AlipayInWechat from "@components/moblie/alipayInWechat";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { getUserInfo } from "@api/user";
import { getPayScheme } from "@api/order";
import { mapGetters } from "vuex";
export default {
  name: "openAlipay",
  components: { AlipayInWechat },
  data() {
    return {
      isAlipay: false,
      payScheme: ""
    };
  },
  computed: mapGetters(["isLogin"]),
  methods: {
    setShareInfoStatus: function() {
      console.log("222");
      console.log("dakai");
      this.isAlipay = !this.isAlipay;
      console.log(this.isAlipay);
      this.setOpenShare();
    },
    toOrderDetail() {
      this.$router.replace({
        path: `/order/detail/${this.$route.query.order_id}`
      });
    },
    setOpenShare: function() {
      var href = this.payScheme;
      console.log("lujing???");
      console.log(href);
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            console.log(res);
            console.log("路径");
            console.log(href);
            var configAppMessage = {
              desc: "支付宝支付",
              title: "支付宝支付",
              link: href
            };
            console.log("已登陆");
            console.log(configAppMessage);
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: "支付宝支付",
            title: "支付宝支付",
            link: href
          };
          console.log("没登陆");
          console.log(configAppMessage);
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      } else {
        console.log(this.$route.query.order_id);
        getPayScheme(this.$route.query.order_id).then(res => {
          console.log("payscheme");
          console.log(res);
          window.location.href = res.data.payScheme;
        });
      }
    }
  },
  created() {
    // console.log('333');
    // window.location.href = href;
    // if (!isWeixin()) {
    //   href = this.$route.query.payScheme;
    //   window.location.href = href;
    //   alert('非微信');
    // }
    // if (!isWeixin()) {
    //   window.location.href = this.$route.query.payScheme;
    // }
  },
  mounted() {
    // console.log('444');
    // window.location.href = href;
    // if (!isWeixin()) {
    //   href = this.$route.query.payScheme;
    //   window.location.href = href;
    //   alert('非微信');
    // }
    this.setOpenShare();
  },

  beforeDestroy() {},
  destroyed() {}
};
</script>

<style scoped>
.container {
  background-color: rgb(245, 245, 249);
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.button {
  background-color: #fff;
  color: rgb(75, 167, 232);
  width: 100%;
  text-align: center;
  padding: 5px;
  font-size: 18px;
  margin: 10px 0;
  border: 1px rgb(75, 167, 232) solid;
}
.result-logo {
  width: 70px;
  height: 98px;
  margin: auto;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: contain;
}
.result-tips {
  max-width: 370px;
  margin: 0 auto 10px;
  padding: 0 15px;
  font-size: 15px;
  color: #a5a5a5;
  line-height: 18px;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
}
.am-button-blue {
  border: 1px solid #0ae;
  color: #fff;
  background: #0ae;
}
</style>
